import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Box,
  IconButton,
  styled,
  Checkbox,
  useTheme,
} from "@mui/material";
import alignCenter from "assets/icons/aligncenter.svg";
import PaginationComponent from "components/ui-components/PaginationComponent";
import rolePackageSlice from "store/slices/apis/rolePackageSlice";
import { useGetAllPMQuery } from "store/slices/apis/pmPackageSlice";
import { useParams } from "react-router-dom";
import moment from "moment";

const StyledTableHead = styled(TableCell)({
  fontWeight: 500,
  fontSize: "14px",
  color: "#505258",
  padding: "10px 14px",
  backgroundColor: "#F8F8F8",
  border: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
});

const StyledTableBody = styled(TableCell)({
  fontWeight: 400,
  fontSize: "14px",
  color: "#5052588A",
  padding: "10px 14px",
  backgroundColor: "#fff",
  border: "1px solid #D8D8D8",
  textAlign: "center",
  whiteSpace: "nowrap",
  lineHeight: "20px",
  letterSpacing: "0.2px",
});

const DeployedEquimentList = () => {
  const { projectId } = useParams();
  const [pageNumber, setPageNumber] = useState(1);
  const theme = useTheme();
  // const totalPages = 2;

  const {
    data: responsedata = {},
    isLoading,
    error,
  } = useGetAllPMQuery({
    projectId,
    sortBy: "ActualDate",
    sortOrder: "desc",
    pageSize: 10,
    page: pageNumber,
    hasActualDate: true,
  });

  const deployedEquipmentData = responsedata?.data || [];
  const totalPages = responsedata?.pagination?.totalPages || 1;

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        mt: 0,
        borderRadius: "12px",
        overflow: "hidden",
        backgroundColor: "white",
        border: "1px solid #D8D8D8",
      }}
    >
      <Box sx={{ p: 2 }}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "100%",
            letterSpacing: "-0.4px",
            color: `${theme?.customSettings?.themeColor}`,
          }}
        >
          Deployment Status
        </Typography>
        <Typography
          sx={{
            mt: "6px",
            color: "#5052588A",
            mb: "18px",
            fontSize: "14px",
            lineHeight: "100%",
            letterSpacing: "-0.4px",
          }}
        >
          Equipment deployment records to support resource planning and control
        </Typography>
      </Box>
      <Paper sx={{ boxShadow: "none" }}>
        <TableContainer>
          <Table sx={{ width: "100%", border: "1px solid #D8D8D8" }}>
            <TableHead>
              <TableRow>
                {["Sl No", "Equipment Name", "Category", "Deployed On"].map(
                  (header) => (
                    <StyledTableHead key={header}>{header}</StyledTableHead>
                  )
                )}
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <StyledTableBody colSpan={5}>Loading...</StyledTableBody>
                </TableRow>
              ) : deployedEquipmentData.length === 0 ? (
                <TableRow>
                  <StyledTableBody colSpan={5}>No data available</StyledTableBody>
                </TableRow>
              ) : (
                deployedEquipmentData.map((row, index) => (
                  <TableRow key={row.id}>
                    <StyledTableBody>
                      {(pageNumber - 1) * 10 + index + 1}
                    </StyledTableBody>
                    <StyledTableBody>{row.pm || "-"}</StyledTableBody>
                    <StyledTableBody>{row.category || "-"}</StyledTableBody>
                    <StyledTableBody>
                      {row.actualDate
                        ? moment(row?.actualDate).format("DD/MM/YYYY")
                        : "-"}
                    </StyledTableBody>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1, pr: 2 }}>
        <PaginationComponent
          pageNumber={pageNumber}
          totalPages={totalPages || 1}
          onPageChange={setPageNumber}
        />
      </Box>
    </Box>
  );
};
export default DeployedEquimentList;
